import { Icons } from '@/src/modules/components/Icons';
import type { DraftSaveStatus } from './useDraftAutosave';
import { cn } from '@/src/infrastructure/lib/utils';

/**
 * Tiny status pill for the wizard header that tells the user their work is
 * being persisted server-side ("Saving…" / "Saved" / "Save failed"). Reassures
 * the user that a refresh or accidental back won't lose progress.
 */
export function DraftSaveIndicator({ status }: { status: DraftSaveStatus }) {
  if (status === 'idle') return null;

  const config = {
    saving: { icon: Icons.Upload, label: 'Saving…', className: 'text-on-surface-variant' },
    saved: { icon: Icons.CheckCircle, label: 'Draft saved', className: 'text-status-published' },
    error: { icon: Icons.Warning, label: 'Save failed — retrying', className: 'text-status-failed' },
  }[status];

  const Icon = config.icon;

  return (
    <span
      role="status"
      aria-live="polite"
      className={cn('flex items-center gap-1.5 text-xs font-semibold', config.className)}
    >
      <Icon
        size={14}
        className={status === 'saving' ? 'animate-pulse' : undefined}
      />
      <span className="hidden sm:inline">{config.label}</span>
    </span>
  );
}
